import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
    imports: [],
    exports: [
        MatIconModule,
        FormsModule,
        ReactiveFormsModule
    ],
    declarations: []
})
export class FavoritesMaterialModule { }
